import { Component } from 'react'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import API from '../../api/api'
import { parseUrl, sortArrayOfObjects } from '../../helpers/helpers'
import ConfirmPopup from '../Popups/ConfirmPopup'

import UserClass from './UserClass/UserClass'

class UserClasses extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start: moment().startOf('month'),
      end: moment().endOf('year'),
      apiError: '',
      expandedClass: '',
      confirmPopupOpened: false,
      classToCancel: {},
      classTypes: [],
      classes: [],
    }
    this.closeConfirmModalCancelClass = this.closeConfirmModalCancelClass.bind(this)
    this.openConfirmModalCancelClass = this.openConfirmModalCancelClass.bind(this)
    this.cancelEventParticipation = this.cancelEventParticipation.bind(this)
    this.fetchPastEvents = this.fetchPastEvents.bind(this)
    this.handleClassAction = this.handleClassAction.bind(this)
  }

  componentDidMount() {
    API.getUserProducts()
      .then((res) => {
        this.setState({ classTypes: res })
      })
      .catch(() => {
        this.setState({ apiError: this.props.t('user-panel:classes.serverError') })
      })
  }

  getPlannedEvents(eventList) {
    return eventList.filter((event) => moment(event.date).isAfter(new Date()))
  }

  getArchiveEvents(eventList) {
    return eventList.filter((event) => !moment(event.date).isAfter(new Date()))
  }

  closeConfirmModalCancelClass() {
    this.setState({ confirmPopupOpened: false })
  }

  openConfirmModalCancelClass(className, event) {
    this.setState({
      confirmPopupOpened: true,
      apiError: '',
      classToCancel: {
        className,
        event,
      },
    })
  }

  cancelEventParticipation() {
    const { className, event } = this.state.classToCancel
    API.signToTraining(event.id)
      .then(() => {
        this.setState({
          confirmPopupOpened: false,
          apiError: '',
          classes: {
            ...this.state.classes,
            [className]: {
              ...this.state.classes[className],
              archive: this.state.classes[className].archive,
              planned: this.state.classes[className].planned.filter((item) => item.id !== event.id),
            },
          },
        })
      })
      .catch(() => {
        this.setState({
          confirmPopupOpened: false,
          apiError: this.props.t('user-panel:classes.cancelError'),
        })
      })
  }

  fetchPastEvents(className, startMonth, endMonth) {
    API.getUserClasses(startMonth, endMonth, className)
      .then((res) => {
        this.setState({
          classes: {
            ...this.state.classes,
            [className]: {
              ...this.state.classes[className],
              archive: {
                startDate: startMonth,
                classes: sortArrayOfObjects(this.getArchiveEvents(res), 'date'),
              },
            },
          },
          apiError: '',
        })
      })
      .catch(() => {
        this.setState({
          apiError: this.props.t('user-panel:classes.downloadError'),
        })
      })
  }

  handleClassAction(e, className) {
    e.preventDefault()
    API.getUserClasses(this.state.start, this.state.end, className)
      .then((res) => {
        this.setState({
          classes: {
            ...this.state.classes,
            [className]: {
              archive: {
                startDate: this.state.start,
                classes: sortArrayOfObjects(this.getArchiveEvents(res), 'date'),
              },
              planned: sortArrayOfObjects(this.getPlannedEvents(res), 'date'),
            },
          },
          expandedClass: this.state.expandedClass !== className ? className : '',
          apiError: '',
        })
      })
      .catch((res) => {
        this.setState({
          classes: {
            ...this.state.classes,
            [className]: res,
          },
          expandedClass: '',
          apiError: this.props.t('user-panel:classes.downloadError'),
        })
      })
  }

  render() {
    const { classTypes, expandedClass, classes, apiError, classToCancel } = this.state
    const { t } = this.props
    return (
      <div className="ctp-classlist">
        {classTypes.map((classType) => {
          return (
            <UserClass
              key={classType.name}
              classData={classType}
              classes={classes[classType.name] !== undefined ? classes[classType.name] : false}
              handleClassAction={this.handleClassAction}
              isExpanded={expandedClass === classType.name}
              fetchPastEvents={(start, end) => this.fetchPastEvents(classType.name, start, end)}
              cancelEventParticipation={(event) =>
                this.openConfirmModalCancelClass(classType.name, event)
              }
              renewUrl={
                classType.productId
                  ? `/dashboard/store/category/${parseUrl(
                      classType.productId.category,
                    )}/product/${parseUrl(classType.productId.name)}`
                  : null
              }
            />
          )
        })}
        {classTypes.length === 0 && apiError === '' && (
          <p className="help">{t('user-panel:classes.notFound')}</p>
        )}
        <p className="help is-danger">{apiError}</p>
        <ConfirmPopup
          isOpen={this.state.confirmPopupOpened}
          title={t('user-panel:classes.cancelTitle')}
          cancelText={t('user-panel:classes.goBack')}
          confirmText={t('common:actions.cancel')}
          confirmCallback={this.cancelEventParticipation}
          cancelCallback={this.closeConfirmModalCancelClass}
          body={
            <div>
              {typeof classToCancel.event !== 'undefined' && (
                <div className="ctp-classlist__rmv-event">
                  <strong>{classToCancel.event.name}</strong>
                  <data>{moment(classToCancel.event.date).format('DD MMM YYYY')}</data>
                  <data>{moment(classToCancel.event.date).format('H:mm')}</data>
                </div>
              )}
              <hr className="ctp-classlist__modal-separator" />
              <p className="ctp-classlist__modal-error">
                {t('user-panel:classes.cancelRefundWarning')}
              </p>
            </div>
          }
        />
      </div>
    )
  }
}

export default withTranslation(['user-panel', 'common'])(UserClasses)
